import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/junglebet/images/logoMB.png';

export default function Index() {
  return <Image src={logo} maxW="150px" ml="2" />;
}
